import { AssistanceTypingsInterface } from '@/components/tickets/tickets-form/interfaces/assistance.typings.interface';
import { Tickets } from '@/modules/shared/shared/domain/constants/constants';

export function assistanceTypingMapping(
    typings: AssistanceTypingsInterface[],
): AssistanceTypingsInterface[] {
    let subCategories = typings.filter(i => i.typing === Tickets.REMOTE_ASSISTANCE.id);
    return subCategories.map(i => {
        return {
            ...i,
            subjects: typings.filter(j => j.typing === i.id),
        };
    });
}
